module.exports = __webpack_public_path__ + "static/media/chess.c4b1a556.jpg";